// import React from "react";
import "./CorporateTwoHome.scss";
import CorporateTwoAbout from "../corporateTwoComponents/CorporateTwoAbout/CorporateTwoAbout";
import CorporateTwoServiceTwo from "../corporateTwoComponents/CorporateTwoServiceTwo/CorporateTwoServiceTwo";
// import CorporateTwoSteps from '../corporateTwoComponents/CorporateTwoSteps/CorporateTwoSteps'
import CorporateTwoNumber from "../corporateTwoComponents/CorporateTwoNumber/CorporateTwoNumber";
import CorporateTwoBlogs from "../corporateTwoComponents/CorporateTwoBlogs/CorporateTwoBlogs";
// import CorporateTwoFooter from "../corporateTwoComponents/CorporateTwoFooter/CorporateTwoFooter";
import CorporateTwoFAQ from "../corporateTwoComponents/CorporateTwoFAQ/CorporateTwoFAQ";
import CorporateTwoTestimonials from "../corporateTwoComponents/CorporateTwoTestimonials/CorporateTwoTestimonials";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";

// IMPORT BANNERS
import BusinessOneBanner from "../../../business/businessOne/businessOneComponents/BusinessOneBanner";
import BusinessThreeBanners from "../../../business/businessThree/businessThreeComponents/BusinessThreeBanners";
import HomeHeroBanners from "../../../../default-components/HomeHeroBanners";
import CorporateTwoBanner from "../../../corporate/corporateTwo/corporateTwoComponents/CorporateTwoBanner/CorporateTwoBanner";
// import CorporateOneBanner from "../../../corporate/corporateOne/corporateOneComponent/CorporateOneBanner";
import CorporateTwoProcess from "../corporateTwoComponents/CorporateTwoProcess/CorporateTwoProcess";
import CorporateTwoClients from "../corporateTwoComponents/CorporateTwoClients/CorporateTwoClients";
import CorporateTwoCallus from "../corporateTwoComponents/CorporateTwoCallus/CorporateTwoCallus";
import CorporateTwoDownloadApp from "../corporateTwoComponents/CorporateTwoDownloadApp/CorporateTwoDownloadApp";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import FooterUpper from "../../../../default-components/FooterUpper";
import CorporateTwoOrderStats from "../corporateTwoComponents/CorporateTwoOrderStats/CorporateTwoOrderStats";
import CorporateTwoFeatures from "../corporateTwoComponents/CorporateTwoFeatures/CorporateTwoFeatures";
import CorporateTwoCategory from "../corporateTwoComponents/CorporateTwoCategory/CorporateTwoCategory";

const CorporateTwoHome = () => {
  const navigate = useNavigate();
  // BANNERS DOCUMENT
  const { document: dbBannersDocuments, error: dbBannersError } = useDocument(
    "settings",
    "banners"
  );

  const { user } = useAuthContext();

  // ACTIVE TEMPLATE DOCUMENT
  const { document: dbActiveTemplateDocuments, error: dbActiveTemplateError } =
    useDocument("settings", "templates");

  let activeTemplate =
    dbActiveTemplateDocuments && dbActiveTemplateDocuments.activeTemplate;

  // Mapping activeBanner values to components
  const bannerComponents = {
    HomeHeroBanners: HomeHeroBanners,
    BusinessOneBanner: BusinessOneBanner,
    BusinessThreeBanners: BusinessThreeBanners,
    // CorporateOneBanner: CorporateOneBanner,
    CorporateTwoBanner: CorporateTwoBanner,
  };

  const handleScheduleBtnClick = () => {
    if (user) {
      navigate("/quick-pickup");
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="smart-wash-home-page">
      {/* <CorporateTwoBanner/> */}
      {dbBannersDocuments &&
        dbBannersDocuments.banners.map((banner, index) => {
          if (banner.templateName === activeTemplate) {
            const BannerComponent = bannerComponents[banner.activeBanner];
            return (
              <div key={index}>
                {BannerComponent && (
                  <BannerComponent
                    category="banner"
                    pageName="home"
                    section="homeherobanners"
                    addMoreVideosButton={false}
                    addMoreTextContentButton={false}
                  />
                )}
              </div>
            );
          } else {
            return null;
          }
        })}

      <div className="schedule-pickup-btn" onClick={handleScheduleBtnClick}>
        <button>
          <span className="material-symbols-outlined">dry_cleaning</span>
          Schedule A Pickup
        </button>
      </div>

      <div
        className="schedule-pickup-btn-mobile-view"
        onClick={handleScheduleBtnClick}
      >
        <button>
          <span className="material-symbols-outlined">dry_cleaning</span>
          Schedule A Pickup
        </button>
      </div>

      {user && <CorporateTwoOrderStats />}

      <CorporateTwoAbout />
      <CorporateTwoCategory/>
      {/* <CorporateTwoFeatures /> */}
      <CorporateTwoServiceTwo />
      {/* <CorporateTwoSteps/> */}
      <CorporateTwoProcess />
      <CorporateTwoNumber />
      <CorporateTwoBlogs />
      <CorporateTwoTestimonials />
      <CorporateTwoFAQ />
      <CorporateTwoCallus />
      <CorporateTwoClients
        category="partners"
        pageName="home"
        section="partners"
        addMoreVideosButton={false}
        addMoreImagesButton={true}
        addMoreTextContentButton={false}
      />
      {/* <CorporateTwoDownloadApp /> */}
      <FooterUpper />
      {/* <CorporateTwoFooter/> */}
    </div>
  );
};

export default CorporateTwoHome;
